import { IconBase } from "@Components/Icons/IconBase";

export class Success extends IconBase {
  protected cssClassName: string = "Success";

  protected get icon(): JSX.Element {
    return (
      <svg viewBox="0 0 32.35 32.35">
        <polygon points="12.86 18.94 8.97 15.06 6.38 17.65 12.86 24.12 12.86 24.12 12.86 24.12 25.8 11.18 23.21 8.59 12.86 18.94" />
        <path d="M16.18,0A16.18,16.18,0,1,0,32.35,16.18,16.19,16.19,0,0,0,16.18,0Zm0,30.75A14.57,14.57,0,1,1,30.75,16.18,14.59,14.59,0,0,1,16.18,30.75Z" />
      </svg>
    );
  }
}
